export const CANCEL = 'Cancel';
export const COMMENT = 'Comment';
export const PLACE_HOLDER = 'Enter your comment here';
